module.exports = __webpack_public_path__ + "static/media/defrag_3.930cd771.ico";